export default "__VITE_ASSET__Cl6QIK04__"